import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';


const StatsPie = ({ title, data, total, colors }) => {
  const filtered = (data || []).filter((d) => d.value > 0);
  const grand = total !== undefined ? total : filtered.reduce((a, b) => a + b.value, 0);

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}} className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-3" data-testid={`stats-pie-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <h3 className="text-sm font-semibold text-center text-gray-700 dark:text-gray-200 mb-1">{title}</h3>
      <div style={{ height: 160, pointerEvents: 'none' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={filtered} dataKey="value" nameKey="label" cx="50%" cy="50%" outerRadius={60} innerRadius={0} label={false}>
              {filtered.map((entry, i) => (
                <Cell key={i} fill={entry.color || colors?.[i % (colors?.length || 1)] || '#6b7280'} stroke="#fff" strokeWidth={1} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div style={{flex:"1 1 auto",display:"flex",flexDirection:"column"}} className="mt-1 space-y-0.5 text-[11px]">
        <div className="space-y-0.5">
          {filtered.map((entry, i) => (
            <div key={i} className="flex items-center gap-1.5 justify-between">
              <div className="flex items-center gap-1.5 truncate">
                <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: entry.color }}></span>
                <span className="text-gray-700 dark:text-gray-300 truncate">{entry.label}:</span>
              </div>
              <span className="font-mono text-gray-900 dark:text-white whitespace-nowrap">
                {entry.value.toLocaleString('id-ID')}
                {grand ? <span className="text-gray-400 ml-1">({((entry.value * 100) / grand).toFixed(1)}%)</span> : null}
              </span>
            </div>
          ))}
        </div>
        <div style={{marginTop:"auto"}} className="pt-1 border-t dark:border-slate-700 text-gray-500 dark:text-gray-400">
          Total: <span className="font-semibold">{grand.toLocaleString('id-ID')}</span>
        </div>
      </div>
    </div>
  );
};

export default StatsPie;
